// extracted by mini-css-extract-plugin
export default {"container":"DetailsLink_container__hdGz7","button":"DetailsLink_button__lf1vh"};